import { render, staticRenderFns } from "./cModalRegisterPay.vue?vue&type=template&id=87d32d5a&scoped=true"
import script from "./cModalRegisterPay.vue?vue&type=script&lang=js"
export * from "./cModalRegisterPay.vue?vue&type=script&lang=js"
import style0 from "./cModalRegisterPay.vue?vue&type=style&index=0&id=87d32d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d32d5a",
  null
  
)

export default component.exports